import React from 'react';
import { IReturnShipments } from '@src/stores/returnStore';
import { ReturnMethodType, RETURN_METHOD } from '../../constants/general';
import { ItemToReturn } from '../../models/returns';
import { UPSDropOffCard } from './UPSDropOffCard';
import { InStoreDropOffCard } from './InStoreDropOffCard';
import { LORPCard } from './LORPCard';

interface ReturnDetailCardProps {
  method: ReturnMethodType;
  shipmentLineItems: ItemToReturn[];
  shipment: IReturnShipments;
  onEditItemSubmit: (
    startingState: ItemToReturn,
    closeDrawer: () => void,
  ) => void;
  onRemoveItemSubmit: (selectedItemId: string) => void;
  isEditSubmitting: boolean;
}

export const ReturnDetailCard = ({
  method,
  shipmentLineItems,
  shipment,
  onEditItemSubmit,
  onRemoveItemSubmit,
  isEditSubmitting,
}: ReturnDetailCardProps) => {
  const shipmentId = shipment?.shipmentId;
  // Skip rendering if no items are assigned to this method
  if (shipmentLineItems.length === 0) return null;

  if (method === RETURN_METHOD.IN_STORE || method === RETURN_METHOD.SORIS) {
    return (
      <InStoreDropOffCard
        key={shipmentId}
        items={shipmentLineItems}
        onEditItemSubmit={onEditItemSubmit}
        onRemoveItemSubmit={onRemoveItemSubmit}
        isEditSubmitting={isEditSubmitting}
      />
    );
  }

  if (method === RETURN_METHOD.UPS_DROP_OFF) {
    return (
      <UPSDropOffCard
        key={shipmentId}
        items={shipmentLineItems}
        returnBoxes={shipment.boxQuantity}
        onEditItemSubmit={onEditItemSubmit}
        onRemoveItemSubmit={onRemoveItemSubmit}
        isEditSubmitting={isEditSubmitting}
      />
    );
  }
  // Keeping this scenario here for when LORP is separated by shipments
  // TODO: Dead code — ReturnDetailCard only receives sortedNonLorpReturnShipments; LORP is
  // grouped and rendered by LORPGroupedReturnDetailCard before this component is ever called.
  if (method === RETURN_METHOD.LORP) {
    return (
      <LORPCard
        key={shipmentId}
        items={shipmentLineItems}
        shipment={shipment}
        onEditItemSubmit={onEditItemSubmit}
        onRemoveItemSubmit={onRemoveItemSubmit}
        isEditSubmitting={isEditSubmitting}
      />
    );
  }

  return null;
};
